import {
    FormControl,
    FormControlLabel,
    FormLabel,
    InputAdornment,
    Radio,
    RadioGroup,
    TextField,
    InputLabel,
    Select,
    MenuItem,
    Autocomplete,
} from "@mui/material";
import React, { useState } from "react";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import Swal from "sweetalert2";
import { useEffect } from "react";
import PlantillaScreen from "../../helpers/PlantillaScreen";

export const PrestamoClientesFiltro = ({
    onCargarRecuperacion,
    recarga,
    estado,
    tablero,
    filtroRazonSocialB,
    setFiltroRazonSocialB,
    filtroTipoSolicitudB,
    setFiltroTipoSolicitudB,
    filtroLineaCreditoB,
    setFiltroLineaCreditoB,
    filtroEstadoB,
    setFiltroEstadoB,
    filtroSucursalB,
    setFiltroSucursalB,
    filtroVendedorB,
    setFiltroVendedorB,
    filtroFolioB,
    setFiltroFolioB,
    onFiltrar,
}) => {
    const [openModal, setOpenModal] = useState(false);
    const [state, setState] = useState(() => {
        const savedState = localStorage.getItem("filtroEstado");
        return savedState
            ? JSON.parse(savedState)
            : {
                ejercicio: "",
                periodo: "",
            };
    });

    const [filtroRazonSocial, setFiltroRazonSocial] = useState([]);
    const [filtroTipoSolicitud, setFiltroTipoSolicitud] = useState([]);
    const [filtroLineaCredito, setFiltroLineaCredito] = useState([]);
    const [filtroEstado, setFiltroEstado] = useState([]);
    const [filtroSucursal, setFiltroSucursal] = useState([]);
    const [filtroVendedor, setFiltroVendedor] = useState([]);
    const [filtroFolio, setFiltroFolio] = useState([]);

    const RazonSocial = Array.from(
        new Set(tablero.map((item) => item.cliente))
    );

    const TipoSolicitud = Array.from(
        new Set(tablero.map((item) => item.tipo_credito))
    );

    const LineaCredito = Array.from(
        new Set(tablero.map((item) => item.linea_credito))
    );

    const Estado = Array.from(new Set(tablero.map((item) => item.estado)));

    const Sucursal = Array.from(new Set(tablero.map((item) => item.sucursal)));

    const Vendedor = Array.from(new Set(tablero.map((item) => item.vendedor)));

    const Folio = Array.from(new Set(tablero.map((item) => item.folio)));

    //   const [openModal, setOpenModal] = useState(false);

    const handleOpenModal = () => {
        setOpenModal(true);
    };

    const handleCloseModal = () => {
        setOpenModal(false);
    };

    const resetFiltros = () => {
        setFiltroRazonSocial([]);
        setFiltroTipoSolicitud([]);
        setFiltroLineaCredito([]);
        setFiltroEstado([]);
        setFiltroSucursal([]);
        setFiltroVendedor([]);
    };

    var año = new Date().getFullYear();
    const handleChangeAño = (event) => {
        setState({ ...state, ejercicio: event.target.value });
    };

    const onOpenModal = () => {
        const container = document.getElementById("analisis-credito-filtro-modal");
        if (!container) return;
        if (openModal) {
            container.style.display = "none";
            setOpenModal(false);
        } else {
            container.style.display = "flex";
            setOpenModal(true);
        }
    };

    const onCargar = () => {
        setFiltroRazonSocialB(filtroRazonSocial);
        setFiltroTipoSolicitudB(filtroTipoSolicitud);
        setFiltroLineaCreditoB(filtroLineaCredito);
        setFiltroEstadoB(filtroEstado);
        setFiltroSucursalB(filtroSucursal);
        setFiltroVendedorB(filtroVendedor);
        setFiltroFolioB(filtroFolio);

        onFiltrar(
            filtroFolio,
            filtroVendedor,
            filtroRazonSocial,
            filtroSucursal,
            filtroEstado,
            filtroTipoSolicitud
        ).then((result) => {
            onOpenModal();
        });
    };

    useEffect(() => {
        if (!recarga) {
            const container = document.getElementById("analisis-credito-filtro-modal");
            if (!container) return;
            container.style.display = "none";
            setOpenModal(false);
        }
        const savedState = localStorage.getItem("filtroEstado");
        if (savedState) {
            onOpenModal();
        }
    }, [recarga]);

    const onBuscar = () => {
        setFiltroFolio(setFiltroFolioB);
    };

    return (
        <div className="mdlFiltros-buro">
            <div className="reporte-buro-credito-filtrado" onClick={onOpenModal}>
                <FilterAltIcon /> Filtrar
            </div>
            <div
                className="analisis-credito-filtro-main"
                id="analisis-credito-filtro-modal"
            >
                <PlantillaScreen
                    titulo={`FILTRO DE OPERACIONES`}
                    className_main={2}
                    className={"solicitud-credito-filtro-plantilla"}
                >
                    <div className="analisis-credito-filtro-inputs-filtrados">
                        <Autocomplete
                            value={filtroVendedor || ""} // Si filtroVendedor es null, se convierte en ""
                            onChange={(event, newValue) => {
                                setFiltroVendedor(newValue || ""); // Si newValue es null, se convierte en ""
                            }}
                            inputValue={filtroVendedor}
                            onInputChange={(event, newInputValue) => {
                                setFiltroVendedor(newInputValue || ""); // Si newInputValue es null, se convierte en ""
                            }}
                            options={Vendedor}
                            renderInput={(params) => (
                                <TextField {...params} label="Vendedor" variant="outlined" />
                            )}
                        />

                        <div className="analisis-credito-filtro-input-razonsocial">
                            <Autocomplete
                                value={filtroRazonSocial || ""} // Si filtroVendedor es null, se convierte en ""
                                onChange={(event, newValue) => {
                                    setFiltroRazonSocial(newValue || ""); // Si newValue es null, se convierte en ""
                                }}
                                inputValue={filtroRazonSocial}
                                onInputChange={(event, newInputValue) => {
                                    setFiltroRazonSocial(newInputValue || ""); // Si newInputValue es null, se convierte en ""
                                }}
                                options={RazonSocial}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Razon Social"
                                        variant="outlined"
                                    />
                                )}
                            />
                        </div>
                        <div className="analisis-credito-filtro-input-sucursal">
                            <Autocomplete
                                value={filtroSucursal || ""} // Si filtroVendedor es null, se convierte en ""
                                onChange={(event, newValue) => {
                                    setFiltroSucursal(newValue || ""); // Si newValue es null, se convierte en ""
                                }}
                                inputValue={filtroSucursal}
                                onInputChange={(event, newInputValue) => {
                                    setFiltroSucursal(newInputValue || ""); // Si newInputValue es null, se convierte en ""
                                }}
                                options={Sucursal}
                                renderInput={(params) => (
                                    <TextField {...params} label="Sucursal" variant="outlined" />
                                )}
                            />
                        </div>


                        {/* <div className="analisis-credito-filtro-input-linea">
                <Autocomplete
                  value={filtroLineaCredito || ""} // Si filtroVendedor es null, se convierte en ""
                  onChange={(event, newValue) => {
                    setFiltroLineaCredito(newValue || ""); // Si newValue es null, se convierte en ""
                  }}
                  inputValue={filtroLineaCredito}
                  onInputChange={(event, newInputValue) => {
                    setFiltroLineaCredito(newInputValue || ""); // Si newInputValue es null, se convierte en ""
                  }}
                  options={LineaCredito}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Linea de credito"
                      variant="outlined"
                    />
                  )}
                />
              </div> */}
                        <div className="analisis-credito-filtro-input-folio">
                            <div className="analisis-credito-input-folio-container">
                                <TextField
                                    fullWidth
                                    size="small"
                                    label="Folio"
                                    className="cel-1 analisis-credito-modal-jdf-content-comentarios-text"
                                    multiline
                                    type="text"
                                    value={filtroFolio}
                                    onChange={(e) => setFiltroFolio(e.target.value)}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="analisis-solicitud-botones">
                        <div
                            className="analisis-solicitud-botones-cancelar"
                            onClick={onOpenModal}
                        >
                            CANCELAR
                        </div>
                        <div
                            className="analisis-solicitud-botones-guardar"
                            onClick={onCargar}
                        >
                            CARGAR
                        </div>
                    </div>
                </PlantillaScreen>
            </div>
        </div>
    );
};
